// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"3533ea91","381":"9183057e","409":"fc532f97","443":"399a768a","496":"0365d9d5"}[chunkId] + ".chunk.js";
};